import {
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from '@mui/material';
import React, { useRef, useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { StyledInputControl } from './index.style';

const PasswordInput = ({
  value,
  handleKeyDown,
  onChange,
  error,
  helperText,
  size = 'small',
  placeholder = 'Nhập mật khẩu',
  name = 'password',
  id,
  disabled,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputRef = useRef(null);

  const handleClickShowPassword = () => {
    if (disabled) return;
    setShowPassword((prev) => !prev);

    // Ensure that the input is always focused at the end.
    setTimeout(() => {
      if (inputRef.current) {
        const { length } = inputRef.current.value;
        inputRef.current.setSelectionRange(length, length);
        inputRef.current.focus();
      }
    }, 0);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <TextField
      inputRef={inputRef}
      id={id}
      size={size}
      placeholder={placeholder}
      name={name}
      type={showPassword ? 'text' : 'password'}
      onKeyDown={handleKeyDown}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      disabled={disabled}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
        tabIndex: disabled ? -1 : 0,
        readOnly: disabled,
      }}
      fullWidth
      props
    />
  );
};

const InputControl = ({ label, className = '', ...rest }) => (
  <StyledInputControl className={className}>
    {label && <Typography>{label}</Typography>}
    <TextField {...rest} />
  </StyledInputControl>
);

export { InputControl, PasswordInput };
